module.exports = __webpack_public_path__ + "img/di_20210901113504.5ce941b6.png";